import { Validators } from '@hugendubel/react-basic';

const CommonAddressFormValidations = {
    addition: { onChange: Validators.optionalOf<string>(Validators.string({ max: 30 })) },
    street: { onChange: Validators.string({ min: 1, max: 100 }) },
    houseNumber: { onChange: Validators.string({ min: 1, max: 10 }) },
    zipCode: {
        onChange: Validators.number({ maxLength: 5 }),
        onBlur: Validators.number({ minLength: 5, maxLength: 5 }),
    },
    city: { onChange: Validators.string({ min: 1, max: 50 }) },
    phone: { onChange: Validators.optionalOf<string>(Validators.string({ max: 30 })) },
    mobilePhone: { onChange: Validators.optionalOf<string>(Validators.string({ max: 30 })) },
};

export const PrivateAddressFormValidations = {
    salutation: { onBlur: Validators.required({ id: 'validation.salutation.required' }) },
    firstName: { onChange: Validators.string({ min: 1, max: 30 }) },
    lastName: { onChange: Validators.string({ min: 1, max: 30 }) },
    ...CommonAddressFormValidations,
};

export const CompanyAddressFormValidations = {
    companyName: { onChange: Validators.string({ min: 1, max: 100 }) },
    ...CommonAddressFormValidations,
};
